import de from "./de.json"
import es from "./es.json"
import fr from "./fr.json"
import zh_cn from "./zh-cn.json"
import pl from "./pl.json"
import ja from "./ja.json"
import nl from "./nl.json"
import pt from "./pt.json"
import it from "./it.json"
import he from "./he.json"
import ko from "./ko.json"
import nb from "./nb.json"
import tr from "./tr.json"
import el from "./el.json"
import ru from "./ru.json"
import ca from "./ca.json"
import id from "./id.json"

export default {
  de,
  es,
  fr,
  zh_cn,
  pl,
  ja,
  nl,
  pt,
  it,
  he,
  ko,
  nb,
  tr,
  el,
  ru,
  ca,
  id,
}
